<script setup lang="ts">
import { AkBadge, AkBadgeColor, AkBadgeSize } from '@ankorstore/design-system';
import { useI18n } from 'vue-i18n';

const props = withDefaults(defineProps<{
  percentage: number;
  size?: AkBadgeSize;
}>(),
  {
    size: AkBadgeSize.Xs,
  }
);

const { t } = useI18n();
</script>

<template>
  <div class="offerBadge">
    <AkBadge
      :content="t('loyalty.fundedDiscount.badge.label', { percentage: props.percentage })"
      symbol="clock-history"
      :color="AkBadgeColor.Purple"
      :size="size"
    />
  </div>
</template>
